/**
 * Pauses for the given delay asynchronously
 * @param milliseconds
 */
export const wait = (milliseconds: number) => new Promise(resolve => setTimeout(resolve, milliseconds));



// WEBPACK FOOTER //
// ./src/utils/time-delay.ts